window.XD = window.XD || {};
window.XD.productCache = {};
window.XD.inventoryCache = {};

window.XD.addOns = async function addOns(data) {
	let response = {
		status: undefined,
		data: undefined
	};

	// Giftbox Logic
	let deliveryMethod = data.get('properties[DeliveryMethod]');
	let giftVariantIds = data.get('properties[_bundle_list]');
	let giftIdsArray = giftVariantIds ? giftVariantIds.split(',').map(id => id.trim()) : [];

	if (deliveryMethod != "Pickup In Store" && giftIdsArray[0]) {
		const variantId = giftIdsArray[0]; // Hotfix add 1 product
		const qty = data.get('quantity') ?? 1;

		// const cartRes = await fetch('/cart.js');
		// const cart = await cartRes.json();

		// const currentQtyInCart = window.XD.getVariantQuantity(cart, variantId);
		// const currentQtyAvailable = await window.XD.getVariantQuantityAvailable(variantId);
		// const maxQty = currentQtyAvailable - currentQtyInCart;

		// if (qty > maxQty) {
		// 	qty = maxQty;
		// 	response = {
		// 		status: false,
		// 		data: {
		// 			"description": "Sản phẩm gift không còn đủ số lượng.",
		// 			"message": "Sản phẩm gift không còn đủ số lượng.",
		// 			status: 422
		// 		}
		// 	}
		// 	return response;
		// }

		let giftWrapId = '#' + Math.floor(1000 + Math.random() * 9000); // Random bundle ID

		await fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				id: variantId,
				quantity: qty,
				properties: {
					_bundle_id: giftWrapId
				}
			})
		})
		.then(res => res.json())
		.then(res => {
			if (res.status === 422) {
				response.status = false;
				response.data = res;

				const bundle_title_properties = data.get('bundle_title_properties');
				if (bundle_title_properties) {
					data.delete(`properties[${bundle_title_properties}]`);
				}
				data.delete('properties[_bundle_list]');
			} else {
				response.status = true;
				response.data = giftWrapId;

				data.set('properties[_bundle_id]', giftWrapId);
			}

			return;
		})
		.catch(err => {
			response.status = false;
			response.data = err;
		});
	} else {
		const bundle_title_properties = data.get('bundle_title_properties');
		if (bundle_title_properties) {
			data.delete(`properties[${bundle_title_properties}]`);
		}
		data.delete('properties[_bundle_list]');
	}

	return response;
}

window.XD.updateAddOns = async function updateAddOns(currentVariant, giftId, bundle_title_properties) {
	window.XD.toggleCheckoutLoading(true);
	try {
		await new Promise(resolve => setTimeout(resolve, 2500)); // Hotfix: Lỗi App discount call API ajax update làm thay đổi key của product, cần chờ nó update xong

		const cartRes = await fetch(`/cart.js?t=${Date.now()}`);
		const cart = await cartRes.json();

		const parentItem = cart.items.find(
			item => item.properties?.['_bundle_id'] == giftId && item.properties?.['_bundle_list']
		);
		const giftItems = cart.items.filter(
			item => item.properties?.['_bundle_id'] === giftId && !item.properties?.['_bundle_list']
		);

		let isUpdateParent;
		if (!parentItem) {
			isUpdateParent = true; // Is remove parent
		} else {
			isUpdateParent = parentItem.id == currentVariant || parentItem.key == currentVariant;
		}
		const parentQty = parentItem?.quantity ?? 0;

		if (isUpdateParent) { // Update QTY child
			if (!giftItems.length) {
				return;
			}
			const updates = {};
			giftItems.forEach(gift => {
				if (gift.quantity !== parentQty) {
					updates[gift.key] = parentQty;
				}
			});
			if (Object.keys(updates).length) {
				await fetch('/cart/update.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ updates })
				});
			}
		} else { // Update properties in parent
			if (!parentItem?.properties) {
				return;
			}
			const newProperties = { ...parentItem.properties };
			// Hotfix add 1 product
			if (bundle_title_properties) {
				delete newProperties[bundle_title_properties];
			}
			delete newProperties['_bundle_list'];
			delete newProperties['_bundle_id'];

			await fetch('/cart/change.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					id: parentItem.key,
					quantity: parentItem.quantity,
					properties: newProperties
				})
			});
		}
	} catch (e) {
		console.error('updateAddOns error', e);
	}
	window.XD.toggleCheckoutLoading(false);
}

window.XD.getVariantQuantity = function getVariantQuantity(currentCart, variantId) {
	if (!currentCart?.items) {
		return 0;
	}
	return currentCart?.items.filter(item => item.variant_id == variantId).reduce((sum, item) => sum + item.quantity, 0);
};

window.XD.fetchInventorySingle = async function fetchInventorySingle(variantId) {
	if (window.XD.inventoryCache?.[variantId]) {
		return window.XD.inventoryCache[variantId];
	}

	const res = await fetch('/apps/click-and-collect-c4de2/storefront/inventory', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'x-shop-domain': Shopify.shop,
		},
		body: JSON.stringify({ productVariantId: variantId }),
	});

	const data = await res.json();
	window.XD.inventoryCache[variantId] = data?.data?.inventoryLevels ?? [];
	return window.XD.inventoryCache[variantId];
}

window.XD.getVariantQuantityAvailable = async function getVariantQuantityAvailable(variantId, locationId = 64066584731) {
	const inventory = await window.XD.fetchInventorySingle(variantId);
	if (!inventory) {
		return 0;
	}
	return inventory.find(item => item.locationId == locationId)?.locationQuantity || 0;
};

window.XD.updateCartNoteFromBundles = async function updateCartNoteFromBundles() {
	window.XD.toggleCheckoutLoading(true);

	try {
		// 1. Fetch cart
		const cartRes = await fetch('/cart.js');
		const cart = await cartRes.json();

		if (!cart?.items?.length) return;

		// 3. Group theo bundle_id
		const bundles = {};
		cart.items.forEach(item => {
			const bundleId = item.properties?._bundle_id;
			if (!bundleId) return;

			if (!bundles[bundleId]) {
				bundles[bundleId] = {
					parent: null,
					child: []
				};
			}

			// Product CHA: có _bundle_list
			if (item.properties?._bundle_list) {
				bundles[bundleId].parent = item;
			}
			// Giftbox: chỉ có _bundle_id
			else {
				bundles[bundleId].child.push(item);
			}
		});

		// 4. Build cart note (barcode)
		const notes = [];
		for (const bundle of Object.values(bundles)) {
			if (!bundle.parent || !bundle.child.length) continue;

			const parentBarcode = await getBarcode(bundle.parent);
			const parentText = `${parentBarcode || bundle.parent.product_title}`;

			const giftboxTexts = [];
			for (const giftbox of bundle.child) {
				const barcode = await getBarcode(giftbox);
				giftboxTexts.push(`${barcode || giftbox.product_title}`);
			}

			notes.push(
				`Hộp quà Crocs: ${giftboxTexts.join(', ')} cho sản phẩm: ${parentText}.`
			);
		}

		const cartNote = notes.length ? notes.join('\n') : "";

		// 4. Update cart note
		await fetch('/cart/update.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ note: cartNote })
		});

		if (atcCart) {
			atcCart.classList.remove('loading-spinner');
		}
		if (btnCheckout.length) {
			btnCheckout.forEach(btn => btn.disabled = false);
		}
	} catch (err) {
		console.error('updateCartNoteFromBundles error:', err);
		window.XD.toggleCheckoutLoading(false);
	}

	async function getBarcode(item) {
		if (!item.handle || !item.variant_id) return null;

		if (!window.XD.productCache[item.handle]) {
			const res = await fetch(`/products/${item.handle}.json`);
			const product = await res.json();
			window.XD.productCache[item.handle] = product?.product ?? {};
		}

		const product = window.XD.productCache[item.handle];
		const variant = product?.variants.find(v => v.id === item.variant_id);

		return variant?.barcode || null;
	}
}


window.XD.toggleCheckoutLoading = async function toggleCheckoutLoading(isLoading) {
	const atcCart = document.querySelector('.cart__checkout-wrapper');
	const btnCheckout = document.querySelectorAll('.cart__checkout');

	if (isLoading) {
		if (atcCart) {
			atcCart.classList.add('loading-spinner');
		}
		if (btnCheckout.length) {
			btnCheckout.forEach(btn => btn.disabled = true);
		}
	} else {
		if (atcCart) {
			atcCart.classList.remove('loading-spinner');
		}
		if (btnCheckout.length) {
			btnCheckout.forEach(btn => btn.disabled = false);
		}
	}
}